<script>
import { required } from "vuelidate/lib/validators";
import Swal from "sweetalert2";

// Custom Components
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";

// Role Component

export default {
  page: {
    title: "Role",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    PageHeader,
  },
  data() {
    return {
      title: "Role",

      isEdit: false,
      isLoading: true,
      roleName: "",
      roleId: null,
      roleTitle: "Add Role Name",
      selectAllCheckBox: false,
      idToBeChange: null,
      submitted: false,
      createError: false,
      errorMessage: null,
      roleList: [],
      isBtnLoading: false,
      allRolePermission: false,
      actId: 0,
    };
  },
  computed: {
    ...authComputed,
    currentProps() {
      return {
        isLoading: this.isLoading,
      };
    },
  },
  validations: {
    roleName: {
      required,
    },
  },
  mounted() {
    this.getRoleList();
  },
  methods: {
    def(none) {
      this.actId = none;
    },

    // Method is used to get list of all role based on hotel
    async getRoleList() {
      await UserService.getRoleList()
        .then((role) => {
          let arrayOfRoles = [];
          role.map(async (item) => {
            const rolePermission = await UserService.getRolePermissionList(
              item.id
            );
            let groupData = rolePermission.reduce((r, a) => {
              a.is_all =
                a.is_view && a.is_add && a.is_update && a.is_delete
                  ? true
                  : false;
              r[JSON.stringify({ menu: a.menu, menu_id: a.menu_id })] = [
                ...(r[JSON.stringify({ menu: a.menu, menu_id: a.menu_id })] ||
                  []),
                a,
              ];
              return r;
            }, {});
            groupData = Object.keys(groupData).map((item) => {
              let data = { menu_status: false };
              data = { ...data, item: JSON.parse(item) };
              return { name: data, groupData: groupData[item] };
            });
            groupData.map((rItem) => {
              item = { ...item, role_status: false };
              item.role_status = rItem.name.menu_status;
            });
            arrayOfRoles.push({ role: item, rolePermission: groupData });
            function compare(a, b) {
              if (a.role.name < b.role.name) {
                return -1;
              }
              if (a.role.name > b.role.name) {
                return 1;
              }
              return 0;
            }
            arrayOfRoles.sort(compare);
          });
          this.roleList = arrayOfRoles;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isBtnLoading = false;
          this.createError = true;
          errorHandler(error);
          if (typeof error.response.data.non_field_errors == "object") {
            this.errorMessage = error.response.data.non_field_errors;
          } else {
            this.errorMessage = error.response.data;
          }
        });
    },
    // Method is use for open role modal
    openRoleModal() {
      this.$bvModal.show("role-modal");
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleSubmit();
    },
    // Method is use to add new role based on hotel
    handleSubmit() {
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        if (this.isEdit !== false) {
          UserService.editRole(this.roleId, {
            name: this.roleName,
          })
            .then(() => {
              this.$bvModal.hide("role-modal");
              Middleware.notification("Successfully updated !!", "success");

              this.isBtnLoading = false;
              // For update role name on DOM
              this.roleList.map((item) => {
                if (item.role.id == this.roleId) {
                  return (item.role.name = this.roleName);
                }
              });
              this.resetModal();
            })
            .catch((error) => {
              this.isBtnLoading = false;
              this.createError = true;
              errorHandler(error);
              if (typeof error.response.data.non_field_errors == "object") {
                this.errorMessage = error.response.data.non_field_errors;
              } else {
                this.errorMessage = error.response.data;
              }
            });
        } else {
          UserService.createRole({
            hotel: this.hotel.id,
            name: this.roleName,
          })
            .then(() => {
              this.$bvModal.hide("role-modal");
              Middleware.notification("Successfully added !!", "success");

              this.isBtnLoading = false;
              this.getRoleList();
              this.resetModal();
            })
            .catch((error) => {
              this.isBtnLoading = false;
              errorHandler(error);

              this.createError = true;
              if (typeof error.response.data.non_field_errors == "object") {
                this.errorMessage = error.response.data.non_field_errors;
              } else {
                this.errorMessage = error.response.data;
              }
            });
        }
      }
    },
    // Method is use for cancel role modal
    cancelSubmit() {
      this.$bvModal.hide("role-modal");
    },
    // Method is used to update role permission based on role
    editRolePermission(roleId, id, data) {
      if (data.check === "All") {
        if (this.idToBeChange !== null) {
          if (this.idToBeChange !== id) {
            this.selectAllCheckBox = false;
          }
        }
        this.idToBeChange = id;
        this.selectAllCheckBox = !this.selectAllCheckBox;
        data = {
          is_view: this.selectAllCheckBox,
          is_add: this.selectAllCheckBox,
          is_update: this.selectAllCheckBox,
          is_delete: this.selectAllCheckBox,
        };
      }
      UserService.updateRolePermissionList(id, data)
        .then(() => {
          Middleware.notification("Status successfully changed !!", "success");
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used to reset add role model
    resetModal() {
      this.roleName = "";
      this.submitted = false;
      this.createError = false;
      this.errorMessage = null;
      this.isEdit = false;
      this.roleTitle = "Add Role Name";
      this.isBtnLoading = false;
    },
    // Method is use for set edit role data
    editRole(data) {
      this.isEdit = true;
      this.roleName = data.name;
      this.roleId = data.id;
      this.roleTitle = "Update Role Name";
      this.$bvModal.show("role-modal");
    },
    // Method is use for delete role
    deleteRole(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this action!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          UserService.deleteRole(id)
            .then(() => {
              this.roleList = this.roleList.filter(
                (item) => item.role.id !== id
              );
              Middleware.notification("Successfully deleted !!", "danger");

              this.isLoading = false;
            })
            .catch((error) => {
              errorHandler(error);
            });
        }
      });
    },
    // Method is use for update role all permissions
    updateAllRolePermission(id, data) {
      UserService.UpdateAllRolePermissions(id, data)
        .then(() => {
          Middleware.notification(
            "Role permissions changed successfully !!",
            "success"
          );

          this.getRoleList();
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is use for update menu status
    updateMenuPermission(id, data) {
      UserService.UpdateAllRolePermissions(id, data)
        .then(() => {
          Middleware.notification(
            "Role permissions changed successfully !!",
            "success"
          );

          this.getRoleList();
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is use for set status
    setStatus(data) {
      data.groupData.map((item) => {
        data.name.menu_status = item.is_all;
        return item;
      });
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      :action="openRoleModal"
      text="Add Role"
      :isButton="true"
    />
    <!-- Model is for add new role into hotel -->
    <b-modal
      id="role-modal"
      centered
      :title="roleTitle"
      hide-footer
      title-class="font-18"
      @hidden="resetModal"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group label="Name" label-for="name-input" class="mb-3">
          <p slot="label" class="mb-2">
            Role Name <span class="text-danger">*</span>
          </p>
          <b-form-input
            id="name-input"
            v-model="roleName"
            placeholder="Add Role name (Ex : House Keeping)"
            autocomplete="off"
            type="text"
            :class="{
              'is-invalid': submitted && $v.roleName.$error,
            }"
          ></b-form-input>
          <div v-if="submitted" class="invalid-feedback">
            <span v-if="!$v.roleName.required">Role name is required.</span>
          </div>
        </b-form-group>
        <div class="row">
          <h4 v-if="createError">
            <template v-if="typeof errorMessage == 'object'">
              <span v-for="error in errorMessage" :key="error">
                <span class="badge card-badge badge-soft-danger">
                  <b>{{ error }}</b>
                </span>
                <br />
              </span>
            </template>
            <template v-else>
              <span class="badge card-badge badge-soft-danger">
                <b>{{ errorMessage }}</b>
              </span>
            </template>
          </h4>
          <div class="col-md-12">
            <b-button
              class="float-end ms-2"
              variant="outline-primary"
              type="reset"
              @click="cancelSubmit"
              >Cancel
            </b-button>
            <b-button
              class="float-end ms-2"
              variant="outline-primary"
              @click="handleOk"
              :class="{ disabled: isBtnLoading }"
            >
              <i
                v-if="isBtnLoading"
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
              ></i>
              {{ isEdit ? "Update" : "Save" }}
            </b-button>
          </div>
        </div>
      </form>
    </b-modal>
    <!-- Here all role permission are display based on role list -->
    <Loader :loading="currentProps">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12">
              <b-tabs
                justified
                nav-class="nav-tabs-custom"
                content-class="p-3 text-muted"
              >
                <b-tab
                  v-for="role in roleList"
                  :key="role.role.id"
                  @click="def(role.role.id)"
                  :active="actId ? actId == role.role.id : false"
                >
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="far fa-user"></i>
                    </span>
                    <span
                      class="d-flex align-items-center justify-content-center"
                      >{{ role.role.name }}
                      <!-- Check box for maintaining all permission -->
                      <div class="form-check form-switch mb-0 ms-2 d-none">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          :id="role.role.id"
                          v-model="role.role.role_status"
                          @click="
                            updateAllRolePermission(role.role.id, {
                              is_all: role.role.role_status ? '1' : '0',
                            })
                          "
                        />
                      </div>
                    </span>

                    <template v-if="role.role.is_deleted">
                      <div class="role-icons d-flex align-items-center">
                        <i
                          class="mdi mdi-trash-can float-end mx-1 fs-4"
                          v-b-popover.hover="'Delete role name'"
                          @click="deleteRole(role.role.id)"
                        ></i>
                        <i
                          class="fas fa-pencil-alt float-end mx-1 fs-5"
                          v-b-popover.hover="'Edit role name'"
                          v-b-modal.role-modal
                          @click="
                            editRole({
                              id: role.role.id,
                              name: role.role.name,
                            })
                          "
                        ></i>
                      </div>
                    </template>
                  </template>
                  <table
                    v-for="(rolePermission, index) in role.rolePermission"
                    class="table"
                    :key="index"
                  >
                    <thead>
                      <tr>
                        <th class="role-heading">
                          <div class="d-flex align-item-center">
                            {{ rolePermission.name.item.menu }}
                            <div class="form-check form-switch mb-0 ms-2">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                :id="role.id"
                                v-model="rolePermission.name.menu_status"
                                @change="
                                  updateMenuPermission(role.role.id, {
                                    menu: rolePermission.name.item.menu_id,
                                    is_all: rolePermission.name.menu_status
                                      ? '1'
                                      : '0',
                                  })
                                "
                                :checked="setStatus(rolePermission)"
                              />
                            </div>
                          </div>
                        </th>
                        <th>View</th>
                        <th>Create</th>
                        <th>Update</th>
                        <th>Delete</th>
                        <th>All</th>
                      </tr>
                    </thead>
                    <tbody
                      v-for="(roleP, index) in rolePermission.groupData"
                      :key="index"
                    >
                      <tr>
                        <td>{{ roleP.page }}</td>
                        <!-- For View -->
                        <td>
                          <div class="form-check form-switch">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              :id="roleP.id"
                              checked
                              v-model="roleP.is_view"
                              @change="
                                editRolePermission(role.role.id, roleP.id, {
                                  is_view: roleP.is_view,
                                });
                                roleP.is_all =
                                  roleP.is_view &&
                                  roleP.is_add &&
                                  roleP.is_update &&
                                  roleP.is_delete
                                    ? true
                                    : false;
                              "
                            />
                            <!-- :id="roleP.is_view" -->
                          </div>
                        </td>
                        <!-- For Create or Add -->
                        <td>
                          <div class="form-check form-switch">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              checked
                              v-model="roleP.is_add"
                              @change="
                                editRolePermission(role.role.id, roleP.id, {
                                  is_add: roleP.is_add,
                                });
                                roleP.is_all =
                                  roleP.is_view &&
                                  roleP.is_add &&
                                  roleP.is_update &&
                                  roleP.is_delete
                                    ? true
                                    : false;
                              "
                            />
                          </div>
                        </td>
                        <!-- For update -->
                        <td>
                          <div class="form-check form-switch">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              checked
                              v-model="roleP.is_update"
                              @change="
                                editRolePermission(role.role.id, roleP.id, {
                                  is_update: roleP.is_update,
                                });
                                roleP.is_all =
                                  roleP.is_view &&
                                  roleP.is_add &&
                                  roleP.is_update &&
                                  roleP.is_delete
                                    ? true
                                    : false;
                              "
                            />
                          </div>
                        </td>
                        <!-- For Delete -->
                        <td>
                          <div class="form-check form-switch">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              checked
                              v-model="roleP.is_delete"
                              @change="
                                editRolePermission(role.role.id, roleP.id, {
                                  is_delete: roleP.is_delete,
                                });
                                roleP.is_all =
                                  roleP.is_view &&
                                  roleP.is_add &&
                                  roleP.is_update &&
                                  roleP.is_delete
                                    ? true
                                    : false;
                              "
                            />
                          </div>
                        </td>
                        <!-- For All -->
                        <td>
                          <div class="form-check form-switch">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              v-model="roleP.is_all"
                              :checked="
                                roleP.is_view &&
                                roleP.is_add &&
                                roleP.is_update &&
                                roleP.is_delete
                                  ? true
                                  : false
                              "
                              @change="
                                editRolePermission(role.role.id, roleP.id, {
                                  check: 'All',
                                });
                                roleP.is_view = roleP.is_all;
                                roleP.is_add = roleP.is_all;
                                roleP.is_update = roleP.is_all;
                                roleP.is_delete = roleP.is_all;
                              "
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>
    </Loader>
  </div>
</template>

<style scoped>
.nav-tabs-custom .nav-item {
  background-color: #eff2f7;
}

.role-heading {
  width: 400px;
}

.role-icons {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}
</style>
